import { Box, Divider, Typography } from '@mui/material';

import Rating from '@mui/material/Rating';


const ReviewCard = ({ review, divide, showWorkshop }) => {
  return (
    <>
    <Box
      sx={{
        my: 1,
        py: 2,
        position: 'relative'
      }}
    >
      {showWorkshop && <Typography sx={{ mb: 1 }}>{review.business}</Typography>}

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mb: review.body ? 1 : 0
        }}
      >
        <Rating name="read-only" value={review.rating} readOnly />
        <Box
          component="span"
          sx={{
            fontSize: 12,
            ml: 1
          }}
        >
          ~ {review.user}
        </Box>
      </Box>

      {review.body && <Typography
        variant="body2"
        fontSize={12}
        fontWeight={300}
        fontStyle="italic"
        lineHeight="20px"
        gutterBottom
      >
        {review.body}
      </Typography>}

      {review.response &&
        <Box sx={{ mt: 2 }}>
          <Typography
            color="primary.light"
            variant="body2"
          >
            ~ Reply
          </Typography>
          <Typography
            variant="body2"
            fontSize={12}
            fontWeight={300}
            fontStyle="italic"
            lineHeight="20px"
            sx={{ ml: 2 }}
          >
            {review.response}
          </Typography>
        </Box>
      }

      <Typography
        variant="body2"
        fontSize={12}
        sx={{
          position: 'absolute',
          bottom: 8,
          right: 8
        }}
      >{review.created}</Typography>
    </Box>
    {divide && <Divider />}
    </>
  );
};

export default ReviewCard;
